import store from '@/plugins/vuex'

const routes = [
  {
    path: '/label/my-channels',
    name: 'Label Channels',
    component: () =>
      import(/* webpackChunkName: 'my-channels-label' */ './views/Index.vue')
  }
]

export default routes
